// extracted by mini-css-extract-plugin
export default {"input":"usingPortsTable_input__8hDpp","main":"usingPortsTable_main__Ot8Oe","content":"usingPortsTable_content__wABnR","header":"usingPortsTable_header__1yACn"};